export default __webpack_public_path__ + "static/media/pass_icon.32717008.svg";